"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.NavigationButton = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const constants_1 = require("../../../icons/constants");
const DownChevronIcon_1 = require("../../../icons/DownChevronIcon");
const LeftChevronIcon_1 = require("../../../icons/LeftChevronIcon");
const RightChevronIcon_1 = require("../../../icons/RightChevronIcon");
const UpChevronIcon_1 = require("../../../icons/UpChevronIcon");
const IconButton_1 = require("../IconButton");
const NavigationButton_module_css_1 = __importDefault(require("./NavigationButton.module.css"));
/**
 * component for navigating left/right/up/down
 */
function NavigationButton({ onClick, direction, size = constants_1.Sizes.Large }) {
    let NavigationIcon;
    switch (direction) {
        case "left":
            NavigationIcon = (0, jsx_runtime_1.jsx)(LeftChevronIcon_1.LeftChevronIcon, { size: size });
            break;
        case "up":
            NavigationIcon = (0, jsx_runtime_1.jsx)(UpChevronIcon_1.UpChevronIcon, { size: size });
            break;
        case "right":
            NavigationIcon = (0, jsx_runtime_1.jsx)(RightChevronIcon_1.RightChevronIcon, { size: size });
            break;
        case "down":
            NavigationIcon = (0, jsx_runtime_1.jsx)(DownChevronIcon_1.DownChevronIcon, { size: size });
            break;
    }
    return ((0, jsx_runtime_1.jsx)("div", { className: NavigationButton_module_css_1.default.navigationButtonContainer, onClick: onClick, children: (0, jsx_runtime_1.jsx)(IconButton_1.IconButton, { size: "SMALL", label: "Navigate " + direction, children: NavigationIcon }) }));
}
exports.NavigationButton = NavigationButton;
//# sourceMappingURL=NavigationButton.js.map